<template>
  <v-dialog v-model="dialog" persistent width="50%">
    <v-btn color="secondary" dark slot="activator">
      <v-icon small>$vuetify.icons.rms_create</v-icon>
      {{ $t('rms.button.add') }}
    </v-btn>
    <v-card class="pa-3">
      <v-card-title primary-title>
        <div class="title">{{ $t('program.create.dialog.title') }}</div>
        <v-spacer></v-spacer>
        <v-btn class="mx-0" small dark icon color="grey" @click.native="close()">
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" onsubmit="return false;">
          <v-text-field
            id="name"
            :label="$t('program.form.label.name')"
            name="name"
            :rules="[
              rules.required,
              rules.min_length(3),
              rules.max_length(250),
            ]"
            counter="250"
            color="primary"
            prepend-icon="$vuetify.icons.rms_agreement"
            type="text"
            v-model="formData.name"
          ></v-text-field>
          <v-flex>
            <DateTimePicker
              name="start_date"
              key="program_startdate"
              :label="$t('program.form.start_date')"
              datetime="srart_date"
              v-model="formData.starts_at" />
            <!-- Showing local time regarding company configured timezone -->
            <ShowLocalTime
              v-if="formData.starts_at"
              key="srart_date"
              :datetime="formData.starts_at"
              :timezone="timezone"
            ></ShowLocalTime>
          </v-flex>

          <!-- end date -->
          <v-flex>
            <DateTimePicker
              name="end_date"
              key="program_end_date"
              :label="$t('program.form.end_date')"
              datetime="end_date"
              v-model="formData.ends_at" />
            <!-- Showing local time regarding company configured timezone -->
            <ShowLocalTime v-if="formData.ends_at" key="end_date" :datetime="formData.ends_at"
              :timezone="timezone">
            </ShowLocalTime>
          </v-flex>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn color="grey" outline @click.native="close()">
          {{ $t('reminder.dialog.box.button.close') }}
        </v-btn>
        <v-btn color="primary" outline :loading="loading" :disabled="loading"
          @click.prevent="create()">
          {{ $t('film.delivery_profile.button.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DateTimePicker from "@/components/DateTimePicker";
import ShowLocalTime from "@/components/ShowLocalTime";
import rules from '@/validation';
import { mapGetters } from 'vuex';
import { tzToUtc } from '@/helper'
import i18n from '@/i18n'
export default {
  name: 'ProgramAddDialog',
  components: {
    DateTimePicker,
    ShowLocalTime
  },
  data() {
    return {
      rules,
      dialog: false,
      formData: {
        name: null,
        starts_at: null,
        ends_at: null
      },

      loading: false
    };
  },

  computed: {
     // timezone
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
      currentCompanyId:'getSelected'
    }),
  },
  methods: {
    async create() {
      try {
        if (!this.$refs.form.validate()) {
          return false;
        }

        const payload = await this.transformFormData(this.formData)

        this.loading = true
        let response = await this.$store.dispatch('program/create', payload);
        this.dialog = false
        this.$store.dispatch("app/showMessage", {
          message: i18n.t('program.creation.successfully.message'),
          color: "success"
        });
        this.goToDetailPage(response.program.id);
        this.$emit('created',response)
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }finally{
        this.loading = false
      }
    },

    transformFormData(formData) {
      let data = Object.assign({}, formData)

      // Transform starts at
      data.starts_at = tzToUtc(
        data.starts_at,
        this.timezone
      );

      // Transform ends at
      data.ends_at = tzToUtc(
        data.ends_at,
        this.timezone
      );

      return data

    },
    close(){
      this.dialog = false;
      this.$refs.form.reset();
    },
    goToDetailPage(programId)
    {
      if(programId){
        this.$router.push({
          name: 'programs.update',
          params: {
            company_id: this.currentCompanyId,
            program_id:programId
          },
        })
      }
    }
  },
};
</script>
